var map = {
	"./50_jahre_frauenstimmrecht.jpg": 60,
	"./_dummy.jpg": 61,
	"./alix-choisy-necker.jpg": 144,
	"./alma-zeli-bacciarini.jpg": 145,
	"./andree-valentin.jpg": 146,
	"./annie-leuch-reineck.jpg": 147,
	"./antoinette-quinche.jpg": 148,
	"./bericht-stellung-der-frau.jpg": 149,
	"./betty-farbstein-ostersetzer.jpg": 150,
	"./carl-hilty.jpg": 151,
	"./charles-schuerch.jpg": 152,
	"./christiane-brunner.jpg": 153,
	"./clara-ragaz.jpg": 154,
	"./clara-zetkin.jpg": 155,
	"./die-elf-ersten-nationalraetinnen.jpg": 156,
	"./elisabeth-kopp.jpg": 157,
	"./elisabeth-schmid-frey.jpg": 158,
	"./elisabeth-vischer-alioth.jpg": 159,
	"./elise-honegger.jpg": 160,
	"./emilie-gourd.jpg": 161,
	"./emilie-kempin-spyri.jpg": 162,
	"./emilie-lieberherr.jpg": 163,
	"./emma-pieczynska-reichenbach.jpg": 164,
	"./gertrud-girard-montet.jpg": 165,
	"./gertrud-heinzelmann.jpg": 166,
	"./gertrud-woker.jpg": 167,
	"./gertrude-guillaume-schack.jpg": 168,
	"./glarner-landsgemeinde.jpg": 169,
	"./hans-oprecht.jpg": 170,
	"./header-mobile.jpg": 171,
	"./header.jpg": 172,
	"./helene-stucki.jpg": 173,
	"./helene-von-muelinen.jpg": 174,
	"./herman-greulich.jpg": 175,
	"./hulda-authenriet-gander.jpg": 176,
	"./iris-von-roten.jpg": 177,
	"./johannes-huber.jpg": 178,
	"./julie-von-may-von-rued.jpg": 179,
	"./katharina-zenhaeusern.jpg": 180,
	"./kollektiv-der-basler-lehrerinnen.jpg": 181,
	"./kursaal.jpg": 182,
	"./lise-girardin.jpg": 183,
	"./lotti-ruckstuhl-thalmessinger.jpg": 184,
	"./lucy-dutoit.jpg": 185,
	"./lydia-benz-burger.jpg": 186,
	"./margarethe-faas-hardegger.jpg": 187,
	"./marie-boehlen.jpg": 188,
	"./marie-goegg-pouchoulin.jpg": 189,
	"./marthe-gosteli.jpg": 190,
	"./meta-von-salis.jpg": 191,
	"./paul-zenhaeusern.jpg": 192,
	"./peter-von-roten.jpg": 193,
	"./rosa-bloch-bollag.jpg": 194,
	"./rosa-neuenschwander.jpg": 195,
	"./theresia-rohner.jpg": 196,
	"./verband-fuer-frauenstimmrecht.jpg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 143;